import { config } from "@nova/configuration/browser"

export const makeBaseEndpoint = () => {
    const environment = config.get("environmentName")
    return environment === "localhost"
        ? "http://localhost:3000"
        : `https://${environment === "production" ? "app" : environment}.mapnova.com`
}

const encodeJsonToBase64UrlSafe = (json: object) =>
    Buffer.from(JSON.stringify(json))
        .toString("base64")
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "")

export const decodeBase64UrlSafeToJson = (encoded: string): object => {
    const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/")
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=")
    return JSON.parse(Buffer.from(padded, "base64").toString("utf-8"))
}

export const appleAuthUrl = (stateKey: string) => {
    const SCOPES = ["name", "email"] as const

    return `https://appleid.apple.com/auth/authorize?${new URLSearchParams({
        client_id: config.get("appleServiceId"),
        redirect_uri: config.get("appleServerRedirectUrl"),
        response_type: "code id_token",
        response_mode: "form_post",
        scope: SCOPES.join(" "),
        state: encodeJsonToBase64UrlSafe({ stateKey, redirectUri: `${makeBaseEndpoint()}/login` }),
    })}`
}

export const microsoftAuthUrl = () => {
    const SCOPES = ["openid", "profile", "email", "User.Read"] as const
    const redirectUri = `${makeBaseEndpoint()}/login`

    const params = new URLSearchParams({
        client_id: config.get("microsoftClientId"),
        response_type: "code",
        redirect_uri: redirectUri,
        response_mode: "query",
        scope: SCOPES.join(" "),
        state: encodeJsonToBase64UrlSafe({ provider: "Microsoft" }),
        prompt: "select_account",
    })

    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params}`
}
